import { assignSealed } from "./utils/assignSealed.js";
export class Resource {
    constructor(name, url, options = {}) {
        this.name = name;
        this.url = url;
        assignSealed(this, options);
    }
}
//# sourceMappingURL=Resource.js.map